import { APP_BAR_FIELDS } from './appBar.js';
import { AVATAR_FIELDS } from './avatar.js';
import { BADGE_FIELDS } from './badge.js';
import { BUTTON_FIELDS } from './button.js';
import { CARD_FIELDS } from './card.js';
import { CAROUSEL_FIELDS } from './carousel.js';
import { CHIP_FIELDS } from './chip.js';
import { DIALOG_FIELDS } from './dialog.js';
import { EMPTY_STATE_FIELDS } from './emptyState.js';
import { INPUT_FIELDS } from './input.js';
import { LAYOUT_FIELDS } from './layout.js';
import { LIST_ITEM_FIELDS } from './listItem.js';
import { LOADING_FIELDS } from './loading.js';
import { ORDER_FIELDS } from './order.js';
import { SHEET_FIELDS } from './sheet.js';
import { TAB_BAR_FIELDS } from './tabBar.js';
import { TEXT_FIELDS } from './text.js';
import { TOAST_FIELDS } from './toast.js';
export { UI_FIELD_DEFAULT_OPTION } from './token-options.js';
export const COMPONENT_UI_CONFIG_FIELDS = {
    layout: LAYOUT_FIELDS,
    button: BUTTON_FIELDS,
    badge: BADGE_FIELDS,
    input: INPUT_FIELDS,
    chip: CHIP_FIELDS,
    card: CARD_FIELDS,
    listItem: LIST_ITEM_FIELDS,
    avatar: AVATAR_FIELDS,
    appBar: APP_BAR_FIELDS,
    tabBar: TAB_BAR_FIELDS,
    sheet: SHEET_FIELDS,
    dialog: DIALOG_FIELDS,
    toast: TOAST_FIELDS,
    emptyState: EMPTY_STATE_FIELDS,
    loading: LOADING_FIELDS,
    carousel: CAROUSEL_FIELDS,
    text: TEXT_FIELDS,
    order: ORDER_FIELDS,
};
export const COMPONENT_UI_CONFIG_NAMES = [
    'layout',
    'button',
    'badge',
    'input',
    'chip',
    'card',
    'listItem',
    'avatar',
    'appBar',
    'tabBar',
    'sheet',
    'dialog',
    'toast',
    'emptyState',
    'loading',
    'carousel',
    'text',
    'order',
];
//# sourceMappingURL=index.js.map